import SectionText from './SectionText';
import SectionPeople from './SectionPeople';
import Slideshow from './Slideshow';
import Text from './Text';
import Image from './Image';
import Embed from './Embed';
import SectionEmbed from './SectionEmbed';

export default {
    SectionText,
    SectionPeople,
    Slideshow,
    Text,
    Image,
    Embed,
    SectionEmbed,
};



// WEBPACK FOOTER //
// ./js/components/blocks/index.js